/**
 * @license Copyright (c) Microsoft Corporation.  All rights reserved.
 */
var TemplateConstants = /** @class */ (function () {
    function TemplateConstants() {
    }
    TemplateConstants.InputParametersLimit = 50;
    TemplateConstants.OutputParametersLimit = 10;
    TemplateConstants.TriggersLimit = 10;
    TemplateConstants.ActionsLimit = 500;
    TemplateConstants.ActionNestingLimit = 8;
    TemplateConstants.OperationConditionsLimit = 10;
    TemplateConstants.TemplateExpressionLimit = 8192;
    TemplateConstants.TemplateLiteralLimit = 131072;
    TemplateConstants.ExpressionResultLimit = 104857600;
    return TemplateConstants;
}());
export { TemplateConstants };
